import React from "react";
import ButtonLoader from "./ButtonLoader";

const ConfirmationModel = ({ onClose, confirmText, onConfirm, isLoading }) => {
  const baseButtonClass =
    "flex items-center justify-center px-6 py-2.5 rounded uppercase transition duration-200";

  return (
    <div className="modal" onClick={onClose}>
      <div
        className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 sm:mx-auto mx-4 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="sm:text-[34px] text-xl mb-3">Confirm {confirmText}?</h2>

        {isLoading ? (
          <ButtonLoader />
        ) : (
          <div className="flex space-x-2 mt-2">
            <button
              className={`${baseButtonClass} text-themeBtn border border-themeBtn`}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className={`${baseButtonClass} bg-themeBtn text-white`}
              onClick={onConfirm}
            >
              Confirm
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmationModel;
